import { render, staticRenderFns } from "./district-update.vue?vue&type=template&id=3c5ecab6&"
import script from "./district-update.vue?vue&type=script&lang=js&"
export * from "./district-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports